import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import Card from '../../Card/Card'
import { getPreAwarenessFlyersHistory, allowRegeneration } from '../../../redux/actions/order-actions'
import { Link } from 'react-router-dom'
import { columnFilters, createSortString, getFormattedDate } from '../../../helper/helperFunctions'
import Pagination from '../../ThemeComponents/Pagination'

class PreAwarenessFlyersHistory extends Component {
    constructor(props) {
        super(props)

        this.state = {
            defaultPageSize: 10,
            filtered: [],
            max_flyer_generation_limit: 0
        }
        this.table = React.createRef();
    }

    filterHandler = (e) => {
        this.setState({
            filtered: [e.target.value]
        })
    }

    allowRegeneration = (e, id) => {
        this.props.allowRegeneration(id).then(
            res => {
                this.pagination.dataCall();
            }
        );
    }

    paginationCall = (data) => {
        let matchFilterWith;
        if (this.pagination) {
            if (this.pagination.reactTable) {
                matchFilterWith = columnFilters(this.pagination.reactTable.state.columns[0].columns)
            }
        }
        let sorted = data.sort.split(',');
        let { sort, orderType } = createSortString(sorted);
        const newData = {
            pageSize: data.pageSize,
            filter: data.filter,
            sort,
            orderType,
            matchFilterWith
        }
        return this.props.getPreAwarenessFlyersHistory(newData).then(
            res => {
                this.setState({
                    max_flyer_generation_limit: res.data.max_flyer_generation_limit
                })
                return res
            }
        );
    }

    render() {
        const columns = [
            {
                Header: 'Program Types',
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: 'Flyer Generation Date',
                        accessor: 'generationDate',
                        className: 'action-center',
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        },
                        filterable: false
                    },
                    {
                        Header: 'Barcode',
                        accessor: 'barcode',
                        width: 200,
                        className: 'action-center',
                        Cell: ({ value, original }) => {
                            return <Link to={'/Admin/' + (original.reorder ? original.reorder : original.id) + '/order-edit'} className="blue_link">{value}</Link>
                        },
                    },
                    {
                        Header: 'Group Name',
                        accessor: 'group_name',
                        className: 'action-center'
                    },
                    {
                        Header: 'Username',
                        accessor: 'username',
                        className: 'action-center',
                    },
                    {
                        Header: 'Password',
                        accessor: 'password',
                        className: 'action-center',
                    },
                    {
                        Header: 'Contact Name',
                        accessor: 'group_leader_contact.first_name',
                        className: 'action-center',
                        id: 'groupLeaderContact.first_name'
                    },
                    {
                        Header: 'Departure Date',
                        accessor: 'order_Dates.departure_date.value',
                        className: 'action-center',
                        id: 'orderDates.departure_date.value',
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                    {
                        Header: 'Contact Log',
                        className: 'action-center',
                        Cell: ({ original }) => {
                            return <Link to={'/Admin/' + (original.reorder ? original.reorder : original.id) + '/order-edit'} className="blue_link">Contact Log</Link>
                        },
                        sortable: false
                    },
                    {
                        Header: 'Flyer Regeneration',
                        className: 'action-center',
                        Cell: ({ original }) => {
                            if (original.flyer_generation_count === this.state.max_flyer_generation_limit) {
                                return <button onClick={(e) => { this.allowRegeneration(e, original.id) }} className='customBtn btn mt-sm btn-primary btn btn-default'>Allow</button>
                            } else {
                                return ''
                            }
                        },
                        sortable: false
                    },
                ]
            }
        ]
        const { /*PreAwarenessFlyersHistory*/ } = this.props
        return (
            <div className='content'>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card content={
                                <React.Fragment>
                                    <div className="secHeading">PreAwareness Flyers History</div>
                                    <div className='flexElem' style={{ justifyContent: 'space-between' }}>
                                        <div className='my-20 col-md-4'>
                                            {/* <input onChange={this.filterHandler} type='text' name='filtered' className='form-control' placeholder='Search...' /> */}
                                        </div>
                                    </div>
                                    {/* <ReactTable
                                        columns={columns}
                                        manual
                                        ref={this.table}
                                        filtered={this.state.filtered}
                                        defaultPageSize={this.state.defaultPageSize}
                                        // pages={programTypesPagination.last_page}
                                        data={PreAwarenessFlyersHistory.data}
                                        onFetchData={(state) => {
                                            let matchFilterWith = [];
                                            state.columns[0].columns.forEach(column => {
                                                if (column.id !== undefined || column.accessor !== undefined) {
                                                    if (column.id) {
                                                        matchFilterWith.push(column.id)
                                                    } else {
                                                        matchFilterWith.push(column.accessor)
                                                    }
                                                }
                                            })
                                            let sort = "", orderType = 'asc', filter = state.filtered.join('');
                                            if (state.sorted.length > 0) {
                                                sort = state.sorted[0].id;
                                                orderType = state.sorted[0].desc;
                                                if (orderType === true) {
                                                    orderType = 'desc'
                                                } else {
                                                    orderType = 'asc'
                                                }
                                            }
                                            const data = {
                                                pageSize: state.pageSize,
                                                filter,
                                                sort,
                                                orderType,
                                                matchFilterWith
                                            }
                                            this.props.getPreAwarenessFlyersHistory(data);
                                        }}
                                    /> */}
                                    <div className='row'>
                                        <Pagination
                                            ref={(p) => this.pagination = p}
                                            showPagination={false}
                                            columns={columns}
                                            pageSize={10}
                                            getDataCall={this.paginationCall}
                                            filterView={true}
                                            // downloadData={true}
                                            // downloadFileName={'Orders'}
                                            // lowerContent = {null}
                                            filterPlaceHolder={'Orders'}
                                            getRowProps={this.getRowProps}
                                        // showAllToggle={true}
                                        />
                                    </div>
                                </React.Fragment>
                            } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { PreAwarenessFlyersHistory, max_flyer_generation_limit } = state.ordersReducer
    return {
        PreAwarenessFlyersHistory,
        max_flyer_generation_limit
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getPreAwarenessFlyersHistory: (data) => { return dispatch(getPreAwarenessFlyersHistory(data)) },
        allowRegeneration: (id) => { return dispatch(allowRegeneration(id)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreAwarenessFlyersHistory)
